// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Tlec","buttons":"RemoveExpirationActionButtons_buttons__3v2Uz"};